import { render } from "./ProcurarRecolha.vue?vue&type=template&id=1bc08c9f"
import script from "./ProcurarRecolha.vue?vue&type=script&lang=js"
export * from "./ProcurarRecolha.vue?vue&type=script&lang=js"
script.render = render

export default script